<template>
	<div>
		<bread-crumbs
			:title="$t('CompanyConfigCrud')"
			:subTitle="$t('general.SubtitleConfigCompany')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		></bread-crumbs>
		<vx-card no-shadow card-border :title="$t('Company')" class="mb-2">
			<label class="vs-input--label">{{ $t("Setting.SelectCompany") }}</label>
			<v-select
				name="status"
				:options="listCompanies"
				v-model="selectedCompany"
				:clearable="false"
				v-validate="'required'"
				value="id"
				label="name"
				:dir="$vs.rtl ? 'rtl' : 'ltr'"
				class="mb-base"
			>
				<template v-slot:no-options="{search, searching}">
					<template v-if="searching">
						{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
					</template>
				</template>
			</v-select>
		</vx-card>

		<vx-card no-shadow card-border>
			<vs-tabs
				v-if="listConfig.length > 0 && !reload && selectedCompany.id > 0"
				:position="isSmallerScreen ? 'top' : 'left'"
				class="tabs-shadow-none"
				id="profile-tabs"
				:key="isSmallerScreen"
				v-model="activeTab"
			>
				<!-- GENERAL -->
				<vs-tab
					icon-pack="feather"
					icon="icon-plus-circle"
					:label="!isSmallerScreen ? $t('Setting.NewConfiguration').toUpperCase() : ''"
				>
					<div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
						<company-config-crud-form
							:data="companyConf"
							:companyId="selectedCompany.id"
							:isGotu="isGotu"
							@updateCompanyConfigEmit="updateCompanyConfigList"
							@typeConfigSelectedEmit="typeConfigSelected"
							@deleteConfigEmit="deleteConfigEmit"
							:update="false"
						/>
					</div>
				</vs-tab>

				<vs-tab
					icon-pack="feather"
					v-for="config in listConfig"
					:key="config.id"
					icon="icon-circle"
					:label="!isSmallerScreen ? config.type_config_name : ''"
				>
					<div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
						<company-config-crud-form
							:data="companyConf"
							:companyId="selectedCompany.id"
							:isGotu="isGotu"
							@updateCompanyConfigEmit="updateCompanyConfigList"
							@deleteConfigEmit="deleteConfigEmit"
							:update="true"
						/>
					</div>
				</vs-tab>
			</vs-tabs>
		</vx-card>
	</div>
</template>

<script>
import vSelect from "vue-select";

import CompanyConfigCrudForm from "./CompanyConfigCrudForm.vue";
import CompanyConf from "@/models/CompanyConf.js";
import moduleCompanyConfigCrud from "@/store/company-config-crud/moduleCompanyConfigCrud.js";
import moduleTypeConfigCrud from "@/store/type-config-crud/moduleTypeConfigCrud";
import moduleCompany from "@/store/company/moduleCompany.js";
import Company from "@/models/Company.js";
import moduleCommon from "@/store/common/moduleCommon.js";

export default {
	components: {
		vSelect,
		CompanyConfigCrudForm,
	},
	data() {
		return {
			activeTab: 0,
			companyConf: new CompanyConf(0, {}),
			selectedCompany: new Company({}),
			reload: false,
		};
	},
	computed: {
		isSmallerScreen() {
			return this.$store.state.windowWidth < 768;
		},
		listConfig() {
			if (this.isGotu) {
				return this.$store.state.moduleCompanyConfigCrud.companies;
			}
			return this.$store.state.moduleCompanyConfigCrud.companies.filter(
				({type_config_name}) =>
					type_config_name === "VISUAL_CONFIG" ||
					type_config_name === "NOTIFICATIONS" ||
					type_config_name === "ON_DEMAND"
			);
		},

		listCompanies() {
			return this.$store.state.moduleCompany.companies;
		},

		isGotu() {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			return userInfo.datarutas_role_name === "GOTU";
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		consultCompanyConfig() {
			this.reload = true;
			this.openLoading();
			// Consulta las configuraciones de compañias existentes
			this.$store
				.dispatch("moduleCompanyConfigCrud/fetchDataListItems")
				.then((res) => {
					this.closeLoading();
					this.reload = false;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		fetchConfigCompanyById(company_id) {
			this.openLoading();
			this.reload = true;
			// Consulta las configuraciones de compañias existentes
			this.$store
				.dispatch("moduleCompanyConfigCrud/fetchConfigCompanyById", company_id)
				.then((res) => {
					this.reload = false;
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		// Se activa al seleccionar editar en ListView
		selectedCompanyEmit(company) {
			this.companyConf = company;
		},
		updateCompanyConfigList() {
			this.fetchConfigCompanyById(this.selectedCompany.id);
		},
		deleteConfigEmit(config) {
			this.deleteData(config.id);
		},
		// Elimina la configuracion de compañia
		deleteData(id) {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			let payload = {
				config_id: id,
				company_id: parseInt(this.selectedCompany.id) || parseInt(userInfo.datarutas_company_id),
			};
			this.$vs.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/removeItemConfigCompany", payload)
				.then((res) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyConfigDelete"),
						text: this.$t("TextConfirmCompanyConfigDelete"),
					});
					this.fetchConfigCompanyById(this.selectedCompany.id);
					this.activeTab = 0;
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
				});
		},
		typeConfigSelected(object) {},
	},
	watch: {
		activeTab(val) {
			if (val === 0) {
				this.companyConf = new CompanyConf(0, {});
			} else {
				if (this.listConfig[val - 1]) {
					this.selectedCompanyEmit(this.listConfig[val - 1]);
				} else {
					this.companyConf = new CompanyConf(0, {});
				}
			}
		},
		selectedCompany(val) {
			this.fetchConfigCompanyById(val.id);
			this.activeTab = 0;
		},
	},
	created() {
		// modulo configuraciones de empresas
		if (!moduleCompanyConfigCrud.isRegistered) {
			this.$store.registerModule("moduleCompanyConfigCrud", moduleCompanyConfigCrud);
			moduleCompanyConfigCrud.isRegistered = true;
		}
		// modulo tipos de configuraciones
		if (!moduleTypeConfigCrud.isRegistered) {
			this.$store.registerModule("moduleTypeConfigCrud", moduleTypeConfigCrud);
			moduleTypeConfigCrud.isRegistered = true;
		}
		// modulo de empresa
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
		// modulo comun
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		const p1 = this.$store.dispatch("moduleTypeConfigCrud/getListConfig");
		const p2 = this.$store.dispatch("moduleCompany/fetchDataListItems");

		this.openLoading();

		Promise.all([p1, p2])
			.then((values) => {
				this.closeLoading();
			})
			.catch((err) => {
				this.closeLoading();
				console.error(err);
			});
	},
	mounted() {
		if (this.$route.params.company_id) {
			const foundCompant = this.listCompanies.find((company) => company.id === this.$route.params.company_id);
			if (foundCompant)
				this.selectedCompany = this.listCompanies.find(
					(company) => company.id === this.$route.params.company_id
				);
		}
	},
};
</script>

<style lang="scss">
#profile-tabs {
	.vs-tabs--content {
		padding: 0;
	}
}
</style>
